/**
 * Telefono ed email dei contatti degli enti, con le stesse regole dell'API: servono alla scheda
 * dell'ente e al registro dei servizi, dove un referente si aggiunge senza lasciare il modulo.
 */

/**
 * Telefono in formato internazionale, con la stessa regola dell'API: separatori ammessi, «00» vale
 * «+», poi prefisso del paese e da 7 a 15 cifre in tutto. Restituisce la forma compatta, o null se
 * il numero non e' in formato internazionale.
 */
export function telefonoInternazionale(valore: string): string | null {
  const compatto = valore.trim().replace(/[\s.\-/()]/g, '')
  const conPiu = compatto.startsWith('00') ? `+${compatto.slice(2)}` : compatto
  return /^\+[1-9][0-9]{6,14}$/.test(conPiu) ? conPiu : null
}
export const telefonoAccettabile = (v: string) => !v.trim() || telefonoInternazionale(v) !== null
export const emailAccettabile = (v: string) => !v.trim() || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim())
export const AIUTO_TELEFONO = 'In formato internazionale, con il prefisso del paese: per esempio +39 075 5720895.'
